var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { ExportarExcel, ExportarPDF, MODOS } from '../../../utils';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { BotaoAdicionar } from '../../../components/botoes';
import BarraPesquisar from '../../../components/grid_pesquisar';
import GridComp, { PaginationModelDefault } from '../../../components/grid';
import { BoxPrincipal, BoxSuperior, BoxGrid } from '../../../components/grid_box';
import { STATUS_API } from '../../../api';
export var FinanceiroListarBase = function (_a) {
    var _b, _c;
    var pagina = _a.pagina, paginaEspecificaPermissao = _a.paginaEspecificaPermissao, rota = _a.rota, rotaAdicionar = _a.rotaAdicionar, colunas = _a.colunas, services = _a.services, _d = _a.exibirBarraSuperior, exibirBarraSuperior = _d === void 0 ? true : _d, _e = _a.exibirBotaoAdicionar, exibirBotaoAdicionar = _e === void 0 ? true : _e, opcaoAdicional = _a.opcaoAdicional, opcaoAdicionalInicio = _a.opcaoAdicionalInicio, filtrosJSX = _a.filtrosJSX, children = _a.children;
    var _f = useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(true), isLoadingInicio = _g[0], setIsLoadingInicio = _g[1];
    var _h = useState(''), textoBusca = _h[0], setTextoBusca = _h[1];
    var _j = useState([]), registros = _j[0], setRegistros = _j[1];
    var _k = useState(0), totalRegistros = _k[0], setTotalRegistros = _k[1];
    var _l = useState(PaginationModelDefault), paginationModel = _l[0], setPaginationModel = _l[1];
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesFuncionalidade = useState(getAcoesFuncionalidade(paginaEspecificaPermissao || pagina))[0];
    useEffect(function () {
        carregarDadosAuxiliares();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel]);
    useEffect(function () {
        if (isLoadingInicio) {
            setIsLoadingInicio(false);
        }
        else {
            setPaginationModel(function (prevPaginationModel) { return (__assign(__assign({}, prevPaginationModel), { page: 0 })); });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textoBusca]);
    var carregarDadosAuxiliares = function () { return __awaiter(void 0, void 0, void 0, function () {
        var combos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!services.getCombosListar)
                        return [2 /*return*/];
                    return [4 /*yield*/, services.getCombosListar()];
                case 1:
                    combos = _a.sent();
                    if ((combos === null || combos === void 0 ? void 0 : combos.Status) === STATUS_API.ERRO) {
                        alert(combos.Mensagem);
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, dados, total_registros;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, services.getDados(textoBusca === '' ? null : textoBusca, null, paginationModel)];
                case 1:
                    resposta = _a.sent();
                    if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                        alert(resposta.Mensagem);
                    }
                    else if (resposta) {
                        dados = resposta.dados, total_registros = resposta.total_registros;
                        setRegistros(dados || []);
                        setTotalRegistros(total_registros || 0);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var OPCOES_FUNCIONALIDADE = {
        ROTA: rota,
        VISUALIZAR: (_b = acoesFuncionalidade[MODOS.VISUALIZAR]) !== null && _b !== void 0 ? _b : false,
        ALTERAR: function (row) { var _a; return typeof acoesFuncionalidade[MODOS.ALTERAR] === 'function' ? acoesFuncionalidade[MODOS.ALTERAR](row) : (_a = acoesFuncionalidade[MODOS.ALTERAR]) !== null && _a !== void 0 ? _a : false; },
        EXCLUIR: (_c = acoesFuncionalidade[MODOS.EXCLUIR]) !== null && _c !== void 0 ? _c : false,
    };
    var baixarPDF = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!services.gerarPDF)
                        return [2 /*return*/];
                    return [4 /*yield*/, services.gerarPDF()];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        try {
                            link = document.createElement('a');
                            link.href = doc;
                            link.download = "relatorio.pdf";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(doc);
                        }
                        catch (error) {
                            console.log('error : ' + error);
                        }
                    }
                    else {
                        alert('Erro ao gerar o pdf');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var baixarExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!services.gerarExcel)
                        return [2 /*return*/];
                    return [4 /*yield*/, services.gerarExcel()];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        try {
                            link = document.createElement('a');
                            link.href = doc;
                            link.download = "relatorio.xls";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(doc);
                        }
                        catch (error) {
                            console.log('error : ' + error);
                        }
                    }
                    else {
                        alert('Erro ao gerar o excel');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(ContainerPainel, __assign({ pagina: pagina, pagina_especifica_permissao: paginaEspecificaPermissao }, { children: [_jsxs(BoxPrincipal, { children: [exibirBarraSuperior && (_jsxs(BoxSuperior, { children: [_jsx(BarraPesquisar, { filtrarGrid: setTextoBusca }), exibirBotaoAdicionar && _jsx(BotaoAdicionar, { pagina: rotaAdicionar || rota, disabled: !acoesFuncionalidade['CADASTRAR'] }), acoesFuncionalidade['EXPORTAR PDF'] && services.gerarPDF && _jsx(ExportarPDF, { onClick: baixarPDF }), acoesFuncionalidade['EXPORTAR EXCEL'] && services.gerarExcel && _jsx(ExportarExcel, { onClick: baixarExcel })] })), filtrosJSX, _jsx(BoxGrid, { children: _jsx(GridComp, { columns: colunas, rows: registros, OPCOES_FUNCIONALIDADE: OPCOES_FUNCIONALIDADE, OPCAO_ADICIONAL: opcaoAdicional, OPCAO_ADICIONAL_INICIO: opcaoAdicionalInicio, TotalRegistros: totalRegistros, isLoading: isLoading, PaginationModel: paginationModel, setPaginationModel: setPaginationModel, initialState: {
                                sorting: {
                                    sortModel: [{ field: 'id', sort: 'asc' }],
                                },
                            } }) })] }), children] })));
};
export default FinanceiroListarBase;
